import PropTypes from 'prop-types';
import React from 'react';

import theme from '@theme';

import Text, { ENUM_COLORS, ENUM_FONTS } from '../Text';

import { Step, StepIcon, StepLabel, StepperContainer } from './styledComponents';

/**
 * Numbered steps separated by chevrons, with the active one highlighted: the wizard steps of a
 * creation form as much as the status flow of an order. The steps are numbered by their position,
 * so the caller only declares their key and their label.
 */
const Stepper = ({ steps, activeStepKey, activeBackgroundColor }) => (
  <StepperContainer>
    {steps.map(({ key, label }, index) => {
      const isActive = key === activeStepKey;

      return (
        <Step key={key}>
          <StepLabel activeBackgroundColor={activeBackgroundColor} isActive={isActive}>
            <StepIcon isActive={isActive}>{index + 1}</StepIcon>
            <Text
              color={isActive ? ENUM_COLORS.DARKEST : ENUM_COLORS.DARK}
              font={isActive ? ENUM_FONTS.TEXT_MIDDLE_BOLD : ENUM_FONTS.TEXT_MIDDLE_NORMAL}
            >
              {label}
            </Text>
          </StepLabel>
          {index !== steps.length - 1 && (
            <img src={'/images/inpulse/chevron-right-dmgrey-small.svg'} />
          )}
        </Step>
      );
    })}
  </StepperContainer>
);

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  activeStepKey: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
};

Stepper.defaultProps = {
  activeStepKey: null,
  activeBackgroundColor: theme.colors.greys.light,
};

export default Stepper;
